import React from 'react';

const AdminDonations = () => {
    return (
        <div className="section-padding">
            <div className="container-custom">
                <h1 className="text-3xl font-bold mb-6">Manage Donations</h1>
                <p className="text-gray-600">Donation management interface coming soon.</p>
            </div>
        </div>
    );
};

export default AdminDonations;
